import React from 'react';
import {
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@mui/material';
import { useParams } from 'react-router-dom';
import { getCustomerFromStorage } from '../../utilities/customerStorage';

function UserInfo(): JSX.Element {
  const params = useParams<{ invoiceId: string }>();

  const { invoiceId } = params;
  const localCustomer = invoiceId
    ? getCustomerFromStorage(invoiceId, process.env.NODE_ENV)
    : null;

  const handleSwaggerClick = (): void => {
    const swaggerUrl = new URL(
      `${process.env.REACT_APP_SHOPPING_API_BASE_URL}/swagger/index.html`
    );

    // TODO: Find a way to always point to latest version.
    swaggerUrl.searchParams.append(
      'urls.primaryName',
      `Luci.Management.Api ${process.env.REACT_APP_API_VERSION}`
    );

    window.open(swaggerUrl.toString(), '_blank');
  };

  let userAuthInfo = <div />;

  userAuthInfo = (
    <>
      <Typography component="h6">View API Documentation</Typography>
      <Typography component="em" color="info">
        Remember to switch API version to the latest
      </Typography>
      <br />
      <Button
        variant="contained"
        color="primary"
        onClick={handleSwaggerClick}
        sx={{ mt: 2 }}
      >
        Authenticate and Open API Docs
      </Button>
    </>
  );

  return (
    <>
      {userAuthInfo}

      {localCustomer && (
        <Table
          aria-label="customer information"
          size="small"
          sx={{ marginTop: 2 }}
        >
          <TableBody>
            <TableRow>
              <TableCell colSpan={2}>
                <Typography variant="h6">Customer Information</Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <strong>Local Storage Key</strong>
              </TableCell>
              <TableCell>{invoiceId}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <strong>Email</strong>
              </TableCell>
              <TableCell>{localCustomer.email}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <strong>Phone</strong>
              </TableCell>
              <TableCell>{localCustomer.phone}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell colSpan={2}>
                <Typography variant="subtitle1">Billing Address</Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>
                {localCustomer.billingAddress?.firstName}{' '}
                {localCustomer.billingAddress?.lastName}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Address Line 1</TableCell>
              <TableCell>{localCustomer.billingAddress?.line1}</TableCell>
            </TableRow>
            {localCustomer.billingAddress?.line2 && (
              <TableRow>
                <TableCell>Address Line 2</TableCell>
                <TableCell>{localCustomer.billingAddress?.line2}</TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell>City</TableCell>
              <TableCell>{localCustomer.billingAddress?.city}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>State</TableCell>
              <TableCell>{localCustomer.billingAddress?.state}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ZIP Code</TableCell>
              <TableCell>{localCustomer.billingAddress?.zip}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Country</TableCell>
              <TableCell>{localCustomer.billingAddress?.country}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell colSpan={2}>
                <Typography variant="subtitle1">Shipping Address</Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>
                {localCustomer.shippingAddress?.firstName}{' '}
                {localCustomer.shippingAddress?.lastName}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Address Line 1</TableCell>
              <TableCell>{localCustomer.shippingAddress?.line1}</TableCell>
            </TableRow>
            {localCustomer.shippingAddress?.line2 && (
              <TableRow>
                <TableCell>Address Line 2</TableCell>
                <TableCell>{localCustomer.shippingAddress?.line2}</TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell>City</TableCell>
              <TableCell>{localCustomer.shippingAddress?.city}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>State</TableCell>
              <TableCell>{localCustomer.shippingAddress?.state}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ZIP Code</TableCell>
              <TableCell>{localCustomer.shippingAddress?.zip}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Country</TableCell>
              <TableCell>{localCustomer.shippingAddress?.country}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      )}
    </>
  );
}

export default UserInfo;
